import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createCompanyPref,
  fetchAllCompanyPrefs,
  updateCompanyPref,
  fetchOneCompanyPref,
  deleteCompanyPref,
  fetchCurrentCompanyPref,
} from "services/companypref";

export const useAllcompanyprefs = (filters = {}) => {
  const query = useQuery({
    queryKey: ["all-companyprefs", filters],
    queryFn: () => {
      return fetchAllCompanyPrefs(filters);
    },
  });
  return query;
};

export const useOnecompanypref = (id) => {
  const query = useQuery({
    queryKey: ["one-companypref", id],
    queryFn: () => {
      if (id) {
        return fetchOneCompanyPref(id);
      }
    },
  });
  return query;
};

export const useCreateCompanyPref = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    queryKey: ["create-companypref"],
    mutationFn: (data) => createCompanyPref(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["all-companyprefs"] });
      queryClient.invalidateQueries({ queryKey: ["current-companypref"] });
    },
  });
};

export const useUpdateCompanyPref = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    queryKey: ["update-companypref"],
    mutationFn: ({ id, data }) => updateCompanyPref(id, data),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["all-companyprefs"] });
      queryClient.invalidateQueries({ queryKey: ["one-companypref", variables.id] });
      queryClient.invalidateQueries({ queryKey: ["current-companypref"] });
    },
  });
};

export const useDeleteCompanyPref = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    queryKey: ["delete-companypref"],
    mutationFn: (id) => deleteCompanyPref(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["all-companyprefs"] });
      queryClient.invalidateQueries({ queryKey: ["one-companypref", id] });
      queryClient.invalidateQueries({ queryKey: ["current-companypref"] });
    },
  });
};

export const useCurrentCompanyPref = (options = {}) => {
  const query = useQuery({
    queryKey: ["current-companypref"],
    queryFn: () => {
      return fetchCurrentCompanyPref();
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...options, // Allow overriding with custom options like enabled
  });
  return query;
};
